import PromiseProxyMixin from '@ember/object/promise-proxy-mixin';
import ObjectProxy from '@ember/object/proxy';
import Verbose from 'mewe/utils/verbose';
import AccountApi from 'mewe/api/account-api';
import Storage from 'mewe/shared/storage';
import FunctionalUtils from 'mewe/shared/functional-utils';
import Session from 'mewe/shared/session';
import { isInJailOrLocked } from 'mewe/utils/jail-utils';
import Service, { inject as service } from '@ember/service';

const ObjectPromiseProxy = ObjectProxy.extend(PromiseProxyMixin);
const verbose = Verbose({ prefix: '[Settings Service]' }).log;

let promise = null;

const settings = [
  'notificationsHideInfo',
  'notificationsIsChatOn',
  'notificationsIsMentionsOn',
  'homeFeedScope',
];

const fetchSettings = () => {
  promise = new Promise((resolve) => {
    const fromStorage = Storage.get(Storage.keys.desktopSettings);

    if (fromStorage) return resolve(fromStorage);

    if (isInJailOrLocked()) return resolve({});

    Session.isAuthenticated().then(({ isAuthenticated, isConfirmed }) => {
      // dont make request if user is not logged in to prevent 401 resp
      // and redirection to login page, needed for public pages
      if (isAuthenticated && isConfirmed) {
        AccountApi.getCustomData('desktopSettings')
          .then((response) => {
            resolve(response.data);
          })
          .catch(() => {
            resolve({}); // api will return error when key is not set
          });
      } else {
        return resolve({});
      }
    });
  });

  return promise;
};

const store = (data, options = {}) => {
  Storage.set(Storage.keys.desktopSettings, data);
  AccountApi.setCustomData('desktopSettings', data)
    .then(() => {
      if (!options.skipSuccessMessage) {
        FunctionalUtils.info(__('Changes in your account have been saved'));
      }
    })
    .catch(() => {
      FunctionalUtils.showDefaultErrorMessage();
    });
};

export default class SettingsService extends Service {
  @service analytics;

  notificationsHideInfo = false;

  notificationsIsChatOn = true;

  notificationsIsMentionsOn = true;

  constructor() {
    super(...arguments);
    fetchSettings().then((response) => {
      verbose('restored desktop settings');

      if (response) {
        try {
          this.setProperties(JSON.parse(response));
          Storage.set(Storage.keys.desktopSettings, response);
        } catch (e) {}
      }
    });
  }

  get loaded() {
    return ObjectPromiseProxy.create({ promise });
  }

  promise() {
    return promise;
  }

  save(key, value, options) {
    this[key] = value;

    store(JSON.stringify(this.getProperties(settings)), options);
  }
}
